import React from 'react';
import styled from 'styled-components';

const IconWrapper = styled.svg<{ size?: number }>`
  width: ${({ size = 16 }) => size}px;
  height: ${({ size = 16 }) => size}px;
  display: inline-block;
`;

const GradientDefs = styled.defs``;

interface AIIconProps {
  size?: number;
  className?: string;
}

const AIIcon: React.FC<AIIconProps> = ({ size = 16, className }) => {
  const gradientId = `ai-gradient-${Math.random().toString(36).substr(2, 9)}`;
  
  return (
    <IconWrapper size={size} viewBox="0 0 24 24" className={className}>
      <GradientDefs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#4F46E5', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#7C3AED', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#EC4899', stopOpacity: 1 }} />
        </linearGradient>
      </GradientDefs>
      
      {/* Outer diamond/star shape */}
      <path
        d="M12 2L14.4 9.6L22 12L14.4 14.4L12 22L9.6 14.4L2 12L9.6 9.6Z"
        fill={`url(#${gradientId})`}
        fillOpacity="0.2"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Inner diamond/star shape */}
      <path
        d="M12 6L13.5 10.5L18 12L13.5 13.5L12 18L10.5 13.5L6 12L10.5 10.5Z"
        fill={`url(#${gradientId})`}
        fillOpacity="0.4"
      />
      
      {/* Central core */}
      <circle
        cx="12"
        cy="12"
        r="2.5"
        fill={`url(#${gradientId})`}
        fillOpacity="0.8"
      />
      
      {/* Sparkle accents */}
      <circle cx="8" cy="8" r="0.8" fill={`url(#${gradientId})`} fillOpacity="0.6" />
      <circle cx="16" cy="8" r="0.8" fill={`url(#${gradientId})`} fillOpacity="0.6" />
      <circle cx="8" cy="16" r="0.8" fill={`url(#${gradientId})`} fillOpacity="0.6" />
      <circle cx="16" cy="16" r="0.8" fill={`url(#${gradientId})`} fillOpacity="0.6" />
    </IconWrapper>
  );
};

export default AIIcon;